import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const AssetTrackingLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/assetTracking'
            : '/dashboard/building-dashboard/asset-tracking'
        }
      >
        <span>
          {t('navbar:upsellingLinks.assetTracking')}
          <NavigationLabel type={NAVIGATION_LABELS.BETA} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

AssetTrackingLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default AssetTrackingLink
